import React from "react";
import { IconButton } from "@material-ui/core";
import { EditIcon, GrabberIcon, EmptyIcon, CloseIcon } from "..";

export const NodeCaption = ({fontColor = "white", title, editable = true, onClickEdit, removable = true, onClickRemove = ()=>{}}) => {
  return (
    <div style={{ padding: 8, display: "flex", flexDirection: "columns", flexWrap: "wrap", borderBottom: "1px solid #2f2c4d" }}>
      <div style={{flex: "1"}}>
        <GrabberIcon style={{fill: fontColor}}/>
      </div>
      <div style={{flex: "9", paddingLeft: 5, paddingRight: 15, paddingTop: 2, color: fontColor}}>{title}</div>
      <div style={{flex: "1"}}>
        {editable ? <IconButton style={{padding:0}} onClick={onClickEdit}><EditIcon style={{fill: fontColor, height: 16}}/></IconButton> : <EmptyIcon/>}
      </div>
      <div style={{flex: "1"}}>
        {removable ? <IconButton style={{padding:0}} onClick={onClickRemove}><CloseIcon style={{fill: fontColor}}/></IconButton> : <EmptyIcon/>}
      </div>
    </div>
  )
}
